(function () {
  let isProcessing = false;

  // Cache so we only fetch once per page load.
  let _chairHandlesCache = null;

  async function getChairHandles() {
    if (_chairHandlesCache) return _chairHandlesCache;

    try {
      const el = document.getElementById("pillow-chair-handles");
      const staticHandles = el ? JSON.parse(el.textContent) : [];

      // Shopify Liquid caps collection.products at 50 in layout files.
      // If we hit the limit, fetch the full list from the Collections API.
      if (staticHandles.length >= 50) {
        const res = await fetch(
          "/collections/pillow-addon-chairs/products.json?limit=250",
        );
        const data = await res.json();
        _chairHandlesCache = data.products.map((p) => p.handle);
      } else {
        _chairHandlesCache = staticHandles;
      }
    } catch (e) {
      _chairHandlesCache = [];
    }

    return _chairHandlesCache;
  }

  function getActiveAddons() {
    try {
      const el = document.getElementById("pillow-active-addons");
      return el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      return [];
    }
  }

  const NECK = {
    handle: "ttracing-threadmark-pillow",
    zakekeUrl:
      "apps/zakeke?pid=7967964823614&handle=ttracing-threadmark-pillow&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/1-threadmark-pillow-black_400x.png?v=1770361711",
    label: "Personalize neck pillow",
    price: "+RM79",
    cls: "addon-line-neck",
  };

  const LUMBAR = {
    handle: "ttracing-threadmark-lumbar-pillow",
    zakekeUrl:
      "apps/zakeke?pid=8079445131326&handle=ttracing-threadmark-lumbar-pillow&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/1new-threadmark-lumbar-pillow-black_400x.png?v=1778485776",
    label: "Personalize lumbar pillow",
    price: "+RM99",
    cls: "addon-line-lumbar",
  };

  const FOOTBALL = {
    handle: "ttracing-threadmark-neck-pillow-football-edition",
    zakekeUrl:
      "apps/zakeke?pid=8124662022206&handle=ttracing-threadmark-neck-pillow-football-edition&locale=en",
    image:
      "//ttracing.my/cdn/shop/files/fifa1-threadmark-pillow-black2_400x.png?v=1781413864",
    label: "Personalize football neck pillow",
    price: "+RM89",
    cls: "addon-line-football",
  };

  async function checkAddonLogic() {
    if (isProcessing) return;
    isProcessing = true;
    const cartEl = document.querySelector(".ast-cart");
    if (!cartEl) {
      isProcessing = false;
      return;
    }

    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      const chairHandles = await getChairHandles();
      const chairItems = cart.items.filter((item) =>
        chairHandles.includes(item.handle),
      );
      const neckItems = cart.items.filter(
        (item) => item.handle === NECK.handle,
      );
      const lumbarItems = cart.items.filter(
        (item) => item.handle === LUMBAR.handle,
      );
      const footballItems = cart.items.filter(
        (item) => item.handle === FOOTBALL.handle,
      );

      // Stamp data-item-key and data-is-pillow-chair on every DOM item.
      // Use attribute-based matching so free gifts rendered in a different order
      // don't cause index misalignment with cart.items from the API.
      const allCartItemEls = Array.from(
        document.querySelectorAll(".ast-cart__item"),
      );

      // If Astra hasn't finished rendering all items yet, just work with what's
      // available. Items present in the DOM are always in API order, so plain
      // index matching is still correct for the subset that exists.
      // The multiple retries scheduled by the fetch interceptor cover the rest.

      // Build a handle→[el] map by reading the product link inside each DOM item.
      // Confirmed from debug: Astra always renders <a href="/products/HANDLE"> inside
      // each .ast-cart__item, and Astra exposes zero data attributes on items.
      // Handle-based matching is order-independent — it doesn't matter if Astra
      // renders the free gift before the chair or vice versa.
      const domByHandle = new Map();
      allCartItemEls.forEach((el) => {
        const href = el.querySelector("a[href*='/products/']")?.getAttribute("href") || "";
        const handle = href.match(/\/products\/([^/?#]+)/)?.[1] || null;
        if (handle) {
          if (!domByHandle.has(handle)) domByHandle.set(handle, []);
          domByHandle.get(handle).push(el);
        }
      });

      const useHandleMap = domByHandle.size > 0;

      // Track per-handle usage count so multiple quantities of the same product
      // are matched in API order within each handle group.
      const handleUseCount = new Map();

      cart.items.forEach((item) => {
        let el = null;
        if (useHandleMap) {
          const count = handleUseCount.get(item.handle) || 0;
          el = domByHandle.get(item.handle)?.[count] || null;
          handleUseCount.set(item.handle, count + 1);
        }
        // No index fallback — if handle not found it means Astra hasn't rendered
        // that item yet. Returning null here is correct: the scheduled retries
        // (800ms, 1800ms) will re-run once the DOM is fully populated.

        if (el) {
          el.dataset.itemKey = item.key;
          el.dataset.isPillowChair = chairHandles.includes(item.handle)
            ? "true"
            : "false";
        }
      });

      chairItems.forEach((chair) => {
        const chairDOM = document.querySelector(
          `.ast-cart__item[data-item-key="${chair.key}"]`,
        );
        if (!chairDOM) return;

        const activeAddons = getActiveAddons();
        const neckLinked =
          !activeAddons.includes(NECK.handle) ||
          neckItems.filter(
            (p) =>
              Number(p.properties._linked_chair_variant_id) ===
              chair.variant_id,
          ).length >= chair.quantity;
        const lumbarLinked =
          !activeAddons.includes(LUMBAR.handle) ||
          lumbarItems.filter(
            (p) =>
              Number(p.properties._linked_chair_variant_id) ===
              chair.variant_id,
          ).length >= chair.quantity;
        const footballLinked =
          !activeAddons.includes(FOOTBALL.handle) ||
          footballItems.filter(
            (p) =>
              Number(p.properties._linked_chair_variant_id) ===
              chair.variant_id,
          ).length >= chair.quantity;

        renderAddonLines(
          chairDOM,
          chair.variant_id,
          neckLinked,
          lumbarLinked,
          footballLinked,
        );
      });

      addZakekeEditButtons(cart);
    } catch (err) {
      console.error("Addon check failed", err);
    } finally {
      isProcessing = false;
      const cartEl = document.querySelector(".ast-cart");
      if (cartEl && cartEl.classList.contains("cart-updating")) {
        cartEl.classList.remove("cart-updating");
      }
    }
  }

  function renderAddonLines(
    chairDOM,
    chairKey,
    neckLinked,
    lumbarLinked,
    footballLinked,
  ) {
    // Clear and re-render all addon rows so order is always consistent
    chairDOM
      .querySelectorAll(
        ".addon-line-neck, .addon-line-lumbar, .addon-line-football",
      )
      .forEach((el) => el.remove());

    const priceRow = chairDOM.querySelector(".ast-cart__item__price-row");
    if (!priceRow) return;

    let insertAfter = priceRow;

    if (!neckLinked) {
      const div = buildAddonDiv(NECK, chairKey);
      insertAfter.insertAdjacentElement("afterend", div);
      insertAfter = div;
    }

    if (!lumbarLinked) {
      const div = buildAddonDiv(LUMBAR, chairKey);
      insertAfter.insertAdjacentElement("afterend", div);
      insertAfter = div;
    }

    if (!footballLinked) {
      const div = buildAddonDiv(FOOTBALL, chairKey);
      insertAfter.insertAdjacentElement("afterend", div);
    }
  }

  function buildAddonDiv(addon, chairKey) {
    const a = document.createElement("a");
    a.className = "addon-line-custom " + addon.cls;
    a.href = `/${addon.zakekeUrl}&linked_chair=${chairKey}`;
    a.innerHTML = `
      <span class="addon-line-badge">Add On ${addon.price}</span>
      <div class="pillow-img"><img src="${addon.image}"></div>
      <div class="addon-line-inner" style="display:flex; justify-content:space-between; font-size:14px; align-items:center; flex: 1;">
        <span>${addon.label}</span>
      </div>
    `;
    return a;
  }

  function setDisabled(btn, disabled) {
    btn.disabled = disabled;
    btn.style.opacity = disabled ? "0.5" : "";
    btn.style.cursor = disabled ? "not-allowed" : "";
    if (disabled) btn.setAttribute("aria-disabled", "true");
    else btn.removeAttribute("aria-disabled");
  }

  function addZakekeEditButtons(cart) {
    cart.items.forEach((item) => {
      const cartItemEl = document.querySelector(
        `.ast-cart__item[data-item-key="${item.key}"]`,
      );
      if (!cartItemEl) return;

      const existingBtn = cartItemEl.querySelector(".zakeke-edit-btn");

      if (
        item.properties?._customization &&
        item.properties._customization !== 0
      ) {
        if (existingBtn) return;

        const removeBtn = cartItemEl.querySelector(".ast-cart__item__remove");
        if (!removeBtn) return;

        const editBtn = document.createElement("a");
        editBtn.href = `/apps/zakeke?pid=${item.product_id}&design=${item.properties._customization}&quantity=${item.quantity}&linked_chair=${item.properties._linked_chair_variant_id}`;
        editBtn.className =
          "ast-button ast-button--sm ast-button--plain ast-button--color-neutral ast-button--radius-md ast-button--icon-only zakeke-edit-btn";
        editBtn.setAttribute("aria-label", "Edit customization");
        editBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`;

        removeBtn.insertAdjacentElement("beforebegin", editBtn);
      } else {
        if (existingBtn) existingBtn.remove();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    checkAddonLogic();
    bindChairQuantityListeners();
    watchAstraCartOpen();
  });

  document.addEventListener("cart:updated", () => {
    checkAddonLogic();
  });

  function watchAstraCartOpen() {
    function observe() {
      const astCart = document.querySelector(".ast-cart");
      if (!astCart) {
        setTimeout(observe, 500);
        return;
      }

      // Re-run when cart opens (existing behaviour).
      new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
          if (
            mutation.attributeName === "class" &&
            astCart.classList.contains("ast-open")
          ) {
            setTimeout(checkAddonLogic, 300);
            break;
          }
        }
      }).observe(astCart, { attributes: true, attributeFilter: ["class"] });

      // Re-run when Astra adds/removes .ast-cart__item nodes anywhere inside the
      // cart. subtree:true is required because .ast-cart__item elements are nested
      // inside Astra's wrapper divs, not direct children of .ast-cart.
      // Safe against infinite loops: addon inserts (addon-line-*) are placed inside
      // .ast-cart__item so they are not .ast-cart__item nodes themselves.
      let itemMutationTimer = null;
      new MutationObserver(function (mutations) {
        const cartItemChanged = mutations.some((m) =>
          Array.from(m.addedNodes).concat(Array.from(m.removedNodes)).some(
            (n) =>
              n.nodeType === 1 &&
              // Direct match: Astra added/removed the item node itself
              (n.classList?.contains("ast-cart__item") ||
                // Wrapped match: Astra inserted a container holding item nodes
                // (n.querySelector is safe here — only fires on actual DOM changes,
                //  not on our addon inserts which go inside existing items)
                n.querySelector?.(".ast-cart__item") !== null),
          ),
        );
        if (!cartItemChanged) return;
        clearTimeout(itemMutationTimer);
        itemMutationTimer = setTimeout(checkAddonLogic, 200);
      }).observe(astCart, { childList: true, subtree: true });
    }
    observe();
  }

  function bindChairQuantityListeners() {
    function isTargetChairItem(el) {
      const itemEl = el.closest(".ast-cart__item");
      return itemEl && itemEl.dataset.isPillowChair === "true";
    }

    document.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest(
          ".ast-quantity__plus, .ast-quantity__minus",
        );
        if (!btn || !isTargetChairItem(btn)) return;
        const cartEl = document.querySelector(".ast-cart");
        if (cartEl) cartEl.classList.add("cart-updating");
      },
      true,
    );

    document.addEventListener("change", (e) => {
      const input = e.target.closest(".ast-quantity input");
      if (!input || !isTargetChairItem(input)) return;
      const cartEl = document.querySelector(".ast-cart");
      if (cartEl) cartEl.classList.add("cart-updating");
    });
  }

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (
      typeof url === "string" &&
      (url.includes("/cart/add") || url.includes("/cart/change"))
    ) {
      // Three staggered attempts: first is quick for fast renders,
      // second catches slower mobile renders, third is a safety net.
      setTimeout(checkAddonLogic, 300);
      setTimeout(checkAddonLogic, 800);
      setTimeout(checkAddonLogic, 1800);
    }

    return response;
  };
})();
